export default "__VITE_ASSET__DlwPwqZZ__"